<template>
	<div class="menu">
		<ul class="nav">
			<template v-for="(item, i) in $parent.nav">
			<li class="nav__item" :key="i" v-if="item.link != '/privacy' && item.link != '/terms'">
				<router-link :to="item.link">
				<span v-if="item.title == 'New Arrivals'">New</span> 
				<template v-if="item.title == 'New Arrivals'">
					Arrivals
				</template>
				<template v-else>
					{{item.title != 'Sale'? item.title : ''}}
				</template>
				<span class="red" v-if="item.title == 'Sale'">Sale</span>
				</router-link>
			</li>
			</template>
			<!-- <div class="nav__item" v-if="$route.name == 'Profile'  || $route.name == 'SellOffers'">
			<a @click="$emit('openSaleSkinModal')">Sale your skin</a>
			</div> -->

      <div class="select-container currency-select-container language-select-container">
        <Select2 v-if="currencies.length > 1" class="select2 single currency-select" v-model="curr" @select="selectCurrency($event)"  :options="currencies" :placeholder="curr" />
      </div>
      <div class="menu-balance" v-if="$parent.isAuth">
        <router-link to="/profile" class="menu-balance__amount">
          <PriceFormatter
            :price="formattedBalance"
            rootClass="menu-balance__price"
          />
        </router-link>
        <button class="menu-balance__add" @click="$emit('openTopUpModal')">
          +
        </button>
      </div>
		</ul>
	</div>
</template>

<script>
/*import Vue from 'vue';
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)*/
import {mapMutations, mapState} from "vuex";
import Select2 from "vue3-select2-component";
import PriceFormatter from "./PriceFormatter.vue";

export default {
	name: 'Menu',
	props: ["userProfile"],
	data: function() {
		return {
			
		}
	},
  components: {
    Select2,
    PriceFormatter
  },
  computed: {
    ...mapState("app", ["currencies", "currency"]),
    curr: {
      set(currency) {
        this.setCurrency(currency)
      },
      get() {
        return this.currency;
      }
    },
    formattedBalance() {
      const balance =
        this.userProfile && this.userProfile.balance !== undefined
          ? this.userProfile.balance
          : 0;
      return parseFloat(balance || 0).toFixed(2);
    }
  },
	methods: {
    selectCurrency(event) {
      this.setCurrency(event.id);
    },
    ...mapMutations("app", ['setCurrency']),
	},
}
</script>

<style scoped>
.menu-balance {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 32px;
  color: #1e2329;
  font-size: 18px;
  line-height: 24px;
}

.menu-balance__amount {
  color: inherit;
  text-decoration: none;
}

.menu-balance__price {
  color: #1e2329;
  font-weight: 700;
}

.menu-balance__add {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ff5f00;
  color: #fff;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
